module.exports = __webpack_public_path__ + "img/mic-icon.c51b655a.svg";